import { InputHTMLAttributes, useEffect, useState } from 'react'

import { maskCpf } from '../../utils'
import { InputRadio } from '..'

import {
  IconArrowLeftSvg,
  IconSearchSvg,
  IconCloseSvg
} from '../../assets/icons/svgComponents'

import * as S from './styles'

type InputTypes = InputHTMLAttributes<HTMLInputElement>

type valuesToRadioProps = {
  name: string
  label: string
}

type InputFilterProps = {
  type: string
  name: string
  placeholder?: string
  onRemove: () => void
  onFilter: () => void
  setFilterValues?: any
  classNameDiv?: any
  filterValues?: any
  optionsToRadio: valuesToRadioProps[]
} & InputTypes

const InputFilter = ({
  type,
  name,
  onRemove,
  onFilter,
  setFilterValues,
  classNameDiv,
  filterValues,
  optionsToRadio,
  ...props
}: InputFilterProps) => {
  const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
  const [valuesToRadio, setValuesToRadio] = useState<valuesToRadioProps[]>()
  const [inputFieldVerify, setInputFieldVerify] = useState(false)
  const [values, setValues] = useState({ key: optionsToRadio[0].name })

  const handleRadio = (value: any) => {
    setFilterValues({ [value]: '' })
    setValues((prev: any) => ({ ...prev, key: value }))
  }

  useEffect(() => {
    setValuesToRadio(optionsToRadio)
  }, [optionsToRadio])

  return (
    <S.Wrapper className={classNameDiv}>
      <S.InputContent>
        <input
          onKeyDown={(e: any) => {
            if (e.key === 'Enter') onFilter()
          }}
          type={type}
          id={name}
          name={name}
          autoComplete={values?.key === 'cpf' ? 'off' : 'on'}
          maxLength={values?.key === 'cpf' ? 14 : 999}
          onChange={(e: any) => {
            if (values?.key === 'cpf') {
              if (maskCpf(e.target.value)) {
                setInputFieldVerify(true)
              } else {
                setInputFieldVerify(false)
              }

              setFilterValues((prev: any) => ({
                ...prev,
                cpf: maskCpf(e.target.value)
              }))
            } else {
              if (e.target.value) {
                setInputFieldVerify(true)
              } else {
                setInputFieldVerify(false)
              }
              setFilterValues((prev: any) => ({
                ...prev,
                [values?.key]: e.target.value
              }))
            }
          }}
          value={
            values?.key === 'cpf'
              ? filterValues?.cpf
              : filterValues?.[values?.key]
          }
          {...props}
        />
        <S.ButtonSearch
          onClick={() => {
            onRemove()
            setInputFieldVerify(false)
          }}
        >
          {inputFieldVerify ? <IconCloseSvg /> : <IconSearchSvg />}
          {inputFieldVerify ? 'Fechar' : 'Filtrar'}
        </S.ButtonSearch>
      </S.InputContent>
      <S.filterContent
        dropdownIsOpen={dropdownIsOpen}
        onClick={() => setDropdownIsOpen(!dropdownIsOpen)}
      >
        <IconArrowLeftSvg />
        <p>Filtro simples</p>
      </S.filterContent>
      {dropdownIsOpen && (
        <S.DropdownContainer>
          <S.DropdownContent>
            {valuesToRadio?.map((item) => (
              <InputRadio
                key={item.name}
                id={item.name}
                name="radio"
                value={item.name}
                label={item.label}
                labelFor={item.name}
                labelColor="#4f4f4f"
                defaultChecked={String(item.name) === String(values.key)}
                onCheck={() => handleRadio(item.name)}
              />
            ))}
          </S.DropdownContent>
        </S.DropdownContainer>
      )}
    </S.Wrapper>
  )
}

export default InputFilter
